import { Card } from "primereact/card";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Button } from "primereact/button";
import React, { useEffect, useRef, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { JVDate } from "../../../shared/JVDate";
import { ICompanyMastDropdown, IBranchMastDropdown, IUsersDropdown } from "../../../models/IDropdown";
import { IPermissionProps, ILogin } from "../../../models/Login";
import { Fetch, ILazyParams } from "../../../shared/Fetch";
import { JVDropdown } from "../../../shared/JVDropdown";
import { JVInput } from "../../../shared/JVInput";
import { Toolbar } from "primereact/toolbar";
import { AssignedSalesForm } from "./AssignedSales";
import { format } from "date-fns";
import { Dialog } from "primereact/dialog";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Filter } from "./Filter";
import { safeFormatDate } from "../../../models/DateFormatMapper";

interface IINActivePOCReports {
    fromDate?: Date | null,
    toDate?: Date | null,
    prime_Vendor?: string | null,
    company_ID?: number | null,
    branch_ID?: number | null,
    salesManager_ID?: number | null,
    vendor_Company_ID?: number | null,
    contact_Person_ID?: number | null
}

interface IINActivePOCReportsTableData {
    vendor_Company_Name: string,
    vendor_Company_ID: number
    totalPO: number,
    totalReq: number,
    totalSub: number,
    eciTotal: number,
    todaySubEnd: number,
    contact_Person_ID: number,
    contact_Person_Name: string
}
const EmptyPrimeVendorPerformanceReports: IINActivePOCReports = {
    fromDate: null,
    toDate: null,
    prime_Vendor: "",
    company_ID: null,
    branch_ID: null,
    salesManager_ID: null,
    vendor_Company_ID: null,

}

const schema = yup.object({
    fromDate: yup.date().nullable(),
    toDate: yup.date().nullable(),
    prime_Vendor: yup.string().nullable(),
    company_ID: yup.number().nullable(),
    branch_ID: yup.number().nullable(),
    salesManager_ID: yup.number().nullable(),
    vendor_Company_ID: yup.number().nullable(),
    frequency: yup.number().nullable(),
});

export const InActivePOCReport = (permissions: IPermissionProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IINActivePOCReportsTableData>, loading: boolean });
    const [companies, setCompanies] = useState<Array<ICompanyMastDropdown>>();
    const [branches, setBranches] = useState<Array<IBranchMastDropdown>>();
    const [salesManager, setSalesManager] = useState<Array<IUsersDropdown>>();
    const [loadIcon, setLoadIcon] = useState(false);
    // const [filter, setFilter] = useState<IINActivePOCReports>();
    const [tFooter, setTFooter] = useState<any>({});
    const [selectedClient, setSelectedClient] = useState<any>();
    const [openAssignSales, setOpenAssignSales] = useState(false);
    const [viewDialogVisible, setViewDialogVisible] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);
    const [filter, setFilter] = useState<IINActivePOCReports>(EmptyPrimeVendorPerformanceReports);

    const [historyData, setHistoryData] = useState({ tableData: [], loading: false } as { tableData: Array<any>, loading: boolean });
    const [lazyParams, setLazyParams] = useState<ILazyParams>({
        first: 0,
        rows: 25,
        page: 1,
        sortField: 'id',
        sortOrder: -1
    });

    const inActivePOC = [{ label: "--Select--", value: "0" },
    { label: "PO", value: 1 },
    { label: "ECI", value: 2 },
    { label: "ECS", value: 3 },
    { label: "SUB", value: 4 },
    ]


    const onPage = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const onSort = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const dt = useRef<any>(null);
    const toast = useRef<any>(null);

    let _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    const { control, handleSubmit, formState: { errors }, reset, watch, setValue } = useForm<IINActivePOCReports>({
        resolver: yupResolver(schema),
        defaultValues: EmptyPrimeVendorPerformanceReports,
        shouldFocusError: false
    });

    const loadCompanies = async () => {
        const response = await Fetch("Dropdown/reqCompanyList", "GET", null, null, null);
        if (response) {
            const data: Array<ICompanyMastDropdown> = await response.json();
            const emptyData = {
                company_ID: 0,
                company_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setCompanies(data);
        }
    }
    const loadBranches = async (company?: number | null | undefined) => {
        let queryParam = company ? `company_id=${company}` : null;
        const response = await Fetch("Dropdown/reqBranchList", "GET", null, queryParam, null);
        if (response) {
            const data: Array<IBranchMastDropdown> = await response.json();
            const emptyData = {
                branch_ID: 0,
                branchName: "-- SELECT --",
                company_ID: 0
            };
            data.unshift(emptyData);
            setBranches(data);
        }
    }
    const loadSales = async (branch: number | null | undefined, company: number | null | undefined, team: number | null | undefined) => {
        let queryParameter = null;
        if (branch != 0 && branch != null) {
            queryParameter = `branch_ID=${branch}`;
        } else if (company != 0 && company != null) {
            queryParameter = `company_ID=${company}`;
        } else if (team != 0 && team != null) {
            queryParameter = `team_ID=${team}`;
        }

        const response = await Fetch("Dropdown/SalesManagerList", "GET", null, queryParameter, null);
        if (response) {
            const data: Array<IUsersDropdown> = await response.json();
            const emptyData = {
                login_ID: 0,
                user_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setSalesManager(data);
        }
    }


    useEffect(() => {
        loadSales(0, 0, 0);
        loadCompanies();
        loadBranches();
    }, []);

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "company_ID") {
                if (value.company_ID != 0) {
                    loadBranches(value.company_ID);
                    loadSales(0, value.company_ID, 0);
                } else {
                    loadBranches();
                    if (value.branch_ID != 0) {
                        loadSales(value.branch_ID, 0, 0);
                    } else {
                        loadSales(0, 0, 0);
                    }
                }
            }

            if (name === "branch_ID") {
                if (value.branch_ID != 0) {
                    loadSales(value.branch_ID, 0, 0);
                } else {
                    if (value.company_ID != 0) {
                        loadSales(0, value.company_ID, 0);
                    } else {
                        loadSales(0, 0, 0);
                    }
                }
            }
        });

        return () => subscription.unsubscribe();
    }, [watch]);

    const loadTableDate = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        setLoadIcon(true);
        // setFilter(body);
        const response = await Fetch("InActivePrimeVendor/getPocUsers", "GET", null, `lazyParams=${JSON.stringify(lazyParams)}&filter=${JSON.stringify(filter)}`, null);
        if (response) {
            const data: Array<any> = await response.json();
            let totalNoOfReq = 0;
            let totalNoOfSub = 0;
            let totalNoOfSubClient = 0;
            let totalNoOfECI = 0;
            let totalNoOfPO = 0;

            data.forEach((d, i) => {
                if (d.totalReq) totalNoOfReq += d.totalReq;
                if (d.totalSub) totalNoOfSub += d.totalSub;
                if (d.totalSubEnd) totalNoOfSubClient += d.totalSubEnd;
                if (d.eciTotal) totalNoOfECI += d.eciTotal;
                if (d.totalPO) totalNoOfPO += d.totalPO;
            });
            const totalRecords: any = {
                total: "Total Records",
                noOfReq: totalNoOfReq,
                noOfSub: totalNoOfSub,
                noOfSubClient: totalNoOfSubClient,
                noOfECI: totalNoOfECI,
                noOfPO: totalNoOfPO,
            };
            const processedData = data.map((item) => ({
                ...item,
                compositeKey: `${item.contact_Person_ID}_${item.sales_ID_Have_Contact_Person}`
            }));
            setTableData({ tableData: processedData, loading: false });
            setTFooter(totalRecords);
            // setTableData({ tableData: data, loading: false });
            setLoadIcon(false);
        }
    };


    const getTableDataCount = async () => {
        const response = await Fetch("InActivePrimeVendor/getPocuserCount", "GET", null, `lazyParams=${JSON.stringify(lazyParams)}&filter=${JSON.stringify(filter)}`, null);
        if (response) {
            const count: number = parseInt(await response.text(), 10);
            setTotalRecords(count);
        }
    }

    const onSubmit = (data: IINActivePOCReports) => {
        let newDate = new Date;
        if (data.fromDate?.toDateString() !== newDate.toDateString() || (data.prime_Vendor !== null && data.prime_Vendor !== "") || (data.company_ID !== null && data.company_ID !== 0) || (data.branch_ID !== null && data.branch_ID !== 0) || (data.salesManager_ID !== null && data.salesManager_ID !== 0) || (data.vendor_Company_ID !== null && data.vendor_Company_ID !== 0)) {
        }
        // loadTableDate(data);
        // getTableDataCount(data)

    };

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center flex justify-content-between bg-white">
            <h5 className="m-0">IN Active Client Performance Reports</h5>
            {permissions.is_Export && <Button label="Export" icon="pi pi-upload" className="p-button-help my-2" onClick={exportCSV} />}
        </div>
    );

    const onClear = () => {
        reset(EmptyPrimeVendorPerformanceReports);
    }

    const onHideAssignedUpdateForm = () => {
        setOpenAssignSales(false);
        setSelectedClient([]);
    };

    const rightToolbarTemplate = () => {
        return (
            <Button label="Assign Sales Manager" onClick={() => {
                if (selectedClient && (selectedClient.length > 0 && selectedClient.length < 21)) {
                    setOpenAssignSales(true);
                } else {
                    if (selectedClient.length > 21) {
                        toast.current.show({ severity: 'warn', detail: 'Cannot Assign more than 20 POC.', life: 3000, });

                    } else {
                        toast.current.show({ severity: 'warn', detail: 'Please select at least 1 POC to Assign.', life: 3000, });
                    }
                }
            }}
            />
        );
    };

    const assignedOn = (rowData: any) => {
        let date;
        if (rowData.createdon) date = format(new Date(rowData.createdon), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const handleViewComment = (rowData: any) => {
        getMailFollowupHistory(rowData)
        setViewDialogVisible(true);
    };

    const getMailFollowupHistory = async (data: any) => {
        setHistoryData({ tableData: historyData.tableData, loading: true });
        const response = await Fetch("InActivePrimeVendor/assignedSalesHistory", "GET", null, `contact_Person_ID=${data.contact_Person_ID}`, null);
        if (response) {
            const data: Array<any> = await response.json();
            setHistoryData({ tableData: data, loading: false });
        } else setHistoryData({ tableData: historyData.tableData, loading: false });

    }

    const pDate1 = (rowData: any) => {
        let date;
        if (rowData.createdon) date = format(new Date(rowData.createdon), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    useEffect(() => {
        loadTableDate();
        getTableDataCount()
    }, [lazyParams, filter]);

    const DateFormat = loginObj?.date_Format;
    return (
        <>
            <Card>
                <Accordion>
                    <AccordionTab header="Filter">
                        <Filter salEffFilter={filter} setSalEffFilter={setFilter} />
                    </AccordionTab>
                </Accordion>
                {/* <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">

                    <JVDate column={6} label="From Date" control={control} name="fromDate" />
                    <JVInput column={6} label="Prime Vendor:" control={control} name="prime_Vendor" placeholder="Enter Prime Vendor" error={errors.prime_Vendor?.message} />
                    <JVDropdown column={6} label='Inactive Type' name='inActiveType' control={control} options={inActivePOC} optionLabel='label' optionValue='value' placeholder='-- Select Type --' />
                    {(_roles.includes(4) || _roles.includes(5) || _roles.includes(1) || _roles.includes(46)) && <JVDropdown column={6} label="Company" control={control} name="company_ID" options={companies} optionLabel="company_Name" optionValue="company_ID" placeholder="Select Company" />}
                    {(_roles.includes(4) || _roles.includes(5) || _roles.includes(1) || _roles.includes(46)) && <JVDropdown column={6} label="Branch" control={control} name="branch_ID" options={branches} optionLabel="branchName" optionValue="branch_ID" placeholder="Select Branch" />}

                    <div className="col-12 md:col-12">
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px' }}>
                            <Button className="field col-12 md:col-6" label="FIND" type="submit" ></Button>
                            <Button className="field col-12 md:col-6 p-button-outlined" label="CLEAR" onClick={onClear} type="button"></Button>
                        </div>
                    </div>
                </form> */}
            </Card>
            <Toolbar className="mb-1 py-0" right={rightToolbarTemplate}></Toolbar>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                ref={dt} size="small" stripedRows showGridlines responsiveLayout="scroll" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                lazy
                resizableColumns columnResizeMode="expand"
                //dataKey="id"
                paginator first={lazyParams.first} rows={lazyParams.rows} rowsPerPageOptions={[25, 50, 100, 200]}
                totalRecords={totalRecords} onPage={onPage}
                onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                emptyMessage="No Users found."
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                scrollable scrollHeight="70vh"
                value={tableData.tableData}
                header={header}
                loading={tableData.loading}
                selection={selectedClient}
                onSelectionChange={(e) => {
                    setSelectedClient(e.value);

                }}
                selectionMode="checkbox"
                dataKey="compositeKey"
            >
                {<Column selectionMode="multiple" />}
                <Column header="SN." body={(data, options) => options.rowIndex + 1} style={{ maxWidth: '4rem' }} footer={""} />
                <Column field="vendor_Company_Name" header="Prime Vendor" sortable style={{ maxWidth: '10rem' }} />
                <Column field="contact_Person_Name" header="POC Name" sortable style={{ maxWidth: '10rem' }} />
                <Column field="contact_Person_EmailID" header="POC Email" sortable style={{ maxWidth: '10rem' }} />
                <Column field="user_Name" header="Sales Manager" sortable style={{ maxWidth: '10rem' }} />
                <Column field="branchName" header="Branch Name" sortable style={{ maxWidth: '10rem' }} />
                <Column field="assignTo" header="Assign To" sortable style={{ maxWidth: '10rem' }} />
                {/* <Column field="createdon" header="Assign On" sortable footer={tFooter.total} style={{ maxWidth: '10rem' }} body={assignedOn} /> */}
                <Column field="createdon" header="Assign On" sortable footer={tFooter.total} style={{ maxWidth: '150px' }} body={(rowData: any) => safeFormatDate(rowData.createdon, "dd/MM/yyyy", DateFormat)} />
                <Column field="daysSinceLastActivity" header="Last Reqs" sortable style={{ maxWidth: '10rem' }} />
                <Column field="totalReq" header="#Reqs" footer={tFooter.noOfReq} className="bg-cyan-100" style={{ marginLeft: "2rem" }} />
                <Column field="totalSub" header="#Sub" footer={tFooter.noOfSub} className="bg-cyan-100" />
                <Column field="totalSubEnd" header="#ECS" footer={tFooter.noOfSubClient} className="bg-cyan-100" />
                <Column field="eciTotal" header="#ECI" footer={tFooter.noOfECI} className="bg-cyan-100" />
                <Column field="totalPO" header="#PO" footer={tFooter.noOfPO} className="bg-cyan-100" />
                <Column header="Logs" body={(rowData) => (<Button icon="pi pi-history" className="p-button-rounded p-button-text ml-2" onClick={() => handleViewComment(rowData)} />)} />

            </DataTable>
            <AssignedSalesForm tableData={selectedClient} open={openAssignSales} hideDialoge={() => onHideAssignedUpdateForm()} toast={toast} />
            <Toast ref={toast} />
            <Dialog visible={viewDialogVisible} style={{ width: '40vw' }} header="History of Assign Sales Manager" modal className="p-fluid" onHide={() => setViewDialogVisible(false)}  >
                <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                    size="small" stripedRows scrollable scrollHeight="65vh"
                    emptyMessage="No requirement found."
                    value={historyData.tableData}
                >
                    <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                    <Column field="contact_Person_Name" header="Contact Person" />
                    <Column field="salesManager_Name" header="Sales Manger" />
                    {/* <Column field="createdon" header="Assigned On" body={pDate1} /> */}
                      <Column field="createdon" header="Assigned On" body={(rowData: any) => safeFormatDate(rowData.createdon, 'dd/MM/yyyy', DateFormat)} />
                    {/* <Column header="Action" body={(rowData) => (<Button className="p-button-rounded p-button-text ml-2" onClick={() => handleViewComment(rowData)} />)} /> */}
                </DataTable>
            </Dialog>
        </>
    );
}